<template>
  <div>
    <MainNavigation 
      page-name="Storybox" 
      :routeIndex="routeIndex"
      :currentClass="currentClass"
      />
    <ClassItemBanner
      v-if="currentClass"
      :sessionActive="sessionActive"
      :currentClass="currentClass"
    />
    <Loader v-if="!currentClass || !liveSession" />
    <SessionData v-if="liveSession" :sessionActive="sessionActive" />
  </div>
</template>

<script>
import MainNavigation from "../components/MainNavigation.vue";
import Loader from "../components/Loader.vue";
import SessionData from "../components/SessionData.vue";
import ClassItemBanner from "../components/ClassItemBanner.vue";

export default {
  name: "LiveSession",
  components: {
    MainNavigation,
    Loader,
    SessionData,
    ClassItemBanner
  },
  props: ["name", "routeIndex"],
  mounted() {
    if (this.sessionActive && this.liveSession.updateSessionTimer > 0){
      // console.log("conditions met")
      this.$store.commit("RERUN_TIMER");
    }
  },
  computed: {
    liveSession(){
      return this.$store.state.currentSession;
    },
    currentClass() {
      for (let i = 0; i < this.$store.state.allClasses.length; i++) {
        const thisClass = this.$store.state.allClasses[i];
        if (thisClass.classInfo.nickname == this.$route.params.name) {
          return this.$store.state.allClasses[i];
        }
      }
      return {
        classId: null,
        classInfo: {
          nickname: null,
          checkedDay: [],
          grade: null,
          subject: null,
        },
        studentList: [],
      };
    },
    sessionActive() {
      if (!this.liveSession.isTimeLimitEnabled){
        return this.liveSession.sessionStarted;
      } else if (this.liveSession.sessionSettings.isTimeLimitEnabled && this.liveSession.updateSessionTimer >= 0){
        return this.liveSession.sessionStarted;
      } else {
        return false;
      }
    }
  },
  created() {
    window.addEventListener('beforeunload', this.beforeWindowUnload)
  },  
  beforeUnmount() {
    window.removeEventListener('beforeunload', this.beforeWindowUnload)
  },
  methods: {
    beforeWindowUnload(e) {
      e.preventDefault()
      e.returnValue = ''
    }
  }
}
</script>

<style lang="scss">
.session-details {
  h3 {
    margin-bottom: 0;
  }
  span {
    font-size: 1.17em;
    &:last-of-type {
      font-size: 1.7em;
      font-weight: bold;
    }
  }
}
</style>